// extracted by mini-css-extract-plugin
export default {"count":"tag_count__BP3fWH+F"};